import translate from '@translate';
import React, { FC } from 'react';
import Grid, { GridItem } from 'src/components/Grid';
import Select from 'src/components/Select';
import TextField from 'src/components/TextField';
import { TransportType } from 'src/types/transport';
import { ConstantsCodeType } from 'src/types/constantsCodes';
import DateTimePicker from 'src/components/DateTimePicker';
import { Typography } from '@mui/material';
import { FormErrorsType, OnChangeType } from '../../types/global';
import { EditKeysType } from './constants';
import { OnChangeMultipleType } from './index';

export interface DetailPropsType {
    onChange: OnChangeType<EditKeysType>;
    onChangeMultiple: OnChangeMultipleType;
    editData: TransportType;
    editErrors: FormErrorsType;
    disableEdit: boolean;
    transportStatusCodes: ConstantsCodeType[];
    transportTypeCodes: ConstantsCodeType[];
    boolNumberCodes: ConstantsCodeType[];
    allowedStatuses: ConstantsCodeType[];
    newTransport: boolean;
    summary?: boolean;
}

const Detail: FC<DetailPropsType> = (props) => {
    return (
        <Grid>
            <GridItem cols={12}>
                <Typography variant="h3" gutterBottom>
                    {translate('transportDetail.detail')}
                </Typography>
            </GridItem>
            <GridItem cols={12}>
                <Grid>
                    <GridItem cols={6}>
                        <Grid>
                            {!props.newTransport && (
                                <>
                                    <GridItem cols={12}>
                                        <Select
                                            options={props.transportStatusCodes}
                                            editableOptions={props.allowedStatuses}
                                            value={props.editData.STATUS}
                                            error={props.editErrors.STATUS}
                                            onChange={(value, error) => props.onChange('STATUS', value, error)}
                                            name="STATUS"
                                            label={translate('transportDetail.transportStatus')}
                                            fullWidth
                                            required
                                            disabled={props.disableEdit || props.summary}
                                        />
                                    </GridItem>
                                    {props.editData?.STATUS === 'suspended' && (
                                        <GridItem cols={12}>
                                            <DateTimePicker
                                                value={props.editData.RELEASE_FROM_SUSPENDED_AT}
                                                error={props.editErrors.RELEASE_FROM_SUSPENDED_AT}
                                                onChange={(value, error) =>
                                                    props.onChange('RELEASE_FROM_SUSPENDED_AT', value, error)
                                                }
                                                name="RELEASE_FROM_SUSPENDED_AT"
                                                label={translate('transportDetail.releaseFromSuspendedAt')}
                                                fullWidth
                                                disabled={props.disableEdit || props.summary}
                                                disablePast
                                                type="dateTime"
                                            />
                                        </GridItem>
                                    )}
                                </>
                            )}
                            <GridItem cols={12}>
                                <TextField
                                    value={props.editData.ESHOP_TRANSPORT_ID}
                                    error={props.editErrors.ESHOP_TRANSPORT_ID}
                                    onChange={(value, error) => props.onChange('ESHOP_TRANSPORT_ID', value, error)}
                                    name="ESHOP_TRANSPORT_ID"
                                    label={translate('transportDetail.eshopTransportId')}
                                    fullWidth
                                    required
                                    disabled={props.disableEdit || props.summary || !props.newTransport}
                                />
                            </GridItem>
                            <GridItem cols={12}>
                                <Select
                                    options={props.transportTypeCodes}
                                    value={props.editData.TYPE}
                                    error={props.editErrors.TYPE}
                                    onChange={() => undefined}
                                    name="TYPE"
                                    label={translate('transportDetail.type')}
                                    fullWidth
                                    required
                                    disabled
                                />
                            </GridItem>
                            {!props.newTransport && (
                                <GridItem cols={12}>
                                    <TextField
                                        value={props.editData.BILLED_WEIGHT}
                                        name="BILLED_WEIGHT"
                                        label={translate('transportDetail.billedWeight')}
                                        fullWidth
                                        type="numberLocale"
                                        disabled
                                    />
                                </GridItem>
                            )}
                        </Grid>
                    </GridItem>
                    <GridItem cols={6}>
                        <Grid>
                            {!props.newTransport && (
                                <GridItem cols={12}>
                                    <DateTimePicker
                                        value={props.editData.CREATED_AT}
                                        label={translate('transportDetail.created')}
                                        fullWidth
                                        disabled
                                        type="dateTime"
                                    />
                                </GridItem>
                            )}
                            <GridItem cols={12}>
                                <DateTimePicker
                                    value={props.editData.EXECUTE_AT}
                                    error={props.editErrors.EXECUTE_AT}
                                    onChange={(value, error) => props.onChange('EXECUTE_AT', value, error)}
                                    name="EXECUTE_AT"
                                    label={translate('transportDetail.executeAt')}
                                    fullWidth
                                    disabled={props.disableEdit || props.summary}
                                    disablePast
                                    type="dateTime"
                                />
                            </GridItem>
                            <GridItem cols={12}>
                                <DateTimePicker
                                    value={props.editData.PICK_UP_AT}
                                    error={props.editErrors.PICK_UP_AT}
                                    onChange={(value, error) => props.onChange('PICK_UP_AT', value, error)}
                                    name="PICK_UP_AT"
                                    label={translate('transportDetail.pickupDate')}
                                    fullWidth
                                    required={props.editData.SHIPPER === 'GEIS'}
                                    disabled={props.disableEdit || props.summary}
                                    disablePast
                                    type="date"
                                />
                            </GridItem>
                            {props.editData.STATUS === 'incorrect' && (
                                <GridItem cols={12}>
                                    <TextField
                                        value={props.editData.INCORRECT_MESSAGE}
                                        name="INCORRECT_MESSAGE"
                                        label={translate('transportDetail.incorrectMessage')}
                                        fullWidth
                                        multiline
                                        disabled
                                        error
                                        errorHelperText=" "
                                    />
                                </GridItem>
                            )}
                        </Grid>
                    </GridItem>
                </Grid>
            </GridItem>
        </Grid>
    );
};

export default Detail;
